import { render } from "./ContentR.vue?vue&type=template&id=2646b714&scoped=true"
import script from "./ContentR.vue?vue&type=script&lang=js"
export * from "./ContentR.vue?vue&type=script&lang=js"

import "./ContentR.vue?vue&type=style&index=0&id=2646b714&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/scga-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2646b714"]])

export default __exports__